export const FAQ_LINK = "https://api.medimo.ai/help/";
export const RECOMMENDED_ENV_FAQ_LINK =
  "https://tayori.com/faq/c563924a340fc9b4ef0c322c12db84031cd5ed31/detail/a606f0b9ec0447b5217f34258c181eff98419760/";
export const USER_GUIDE_LINK =
  "https://api.medimo.ai/help/%E3%82%B9%E3%82%BF%E3%83%BC%E3%82%BF%E3%83%BC%E3%82%AC%E3%82%A4%E3%83%89-69f06544ddfd1a13966320de";
export const APPLICATION_ID =
  process.env.NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID ?? "";
export const CLIENT_TOKEN =
  process.env.NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN ?? "";
export const RUM_ENV = process.env.NEXT_PUBLIC_DATADOG_RUM_ENV ?? "";
export const NEXT_PUBLIC_DATADOG_ENDPOINT =
  process.env.NEXT_PUBLIC_DATADOG_ENDPOINT ?? "";
export const API_URL = process.env.NEXT_PUBLIC_API_URL ?? "";
export const HELP_LINK = `${API_URL}/help/`;
export const CONTACT_FORM_LINK = `${API_URL}/help/contact`;
export const IS_DATADOG_ENABLED =
  process.env.NEXT_PUBLIC_IS_DATADOG_ENABLED === "true";
export const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "";
export const POSTHOG_API_KEY = process.env.NEXT_PUBLIC_POSTHOG_API_KEY ?? "";
export const POSTHOG_ENABLED =
  process.env.NEXT_PUBLIC_POSTHOG_ENABLED === "true";
